module.exports = __webpack_public_path__ + "img/icon-contact.1b7c95e6.png";